import { ReactNode } from 'react';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { FormControl, FormControlLabel } from '@mui/material';

interface SwitchFieldProps extends Omit<SwitchProps, 'name' | 'onChange' | 'checked' | 'value' | 'inputProps'> {
	input: {
		checked?: boolean;
		value?: any;
		name?: string;
		onChange?: SwitchProps['onChange'];
		[key: string]: any;
	};
	meta?: any;
}

const SwitchField = ({input: {checked, value, name, onChange, ...restInput}, meta, ...rest}: SwitchFieldProps) => (
	<Switch
		{...rest}
		name={name}
		inputProps={restInput}
		onChange={onChange}
		checked={!!checked}
		value={value}
	/>
);

interface LabelledSwitchProps extends SwitchFieldProps {
	label?: ReactNode;
}

const LabelledSwitch = ({label, ...otherProps}: LabelledSwitchProps) => (
	<FormControl>
		<FormControlLabel label={label} control={<SwitchField {...otherProps}/>}/>
	</FormControl>
);

export default SwitchField;
export {LabelledSwitch};
